import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import dayjs from 'dayjs'
import useBlockDetail from '../../hooks/queries/useBlockDetail'
import MainContentDiv from '../../components/templates/MainContent'
import SearchContainer from '../../components/organisms/SearchContainer'
import Search from '../Search'
import ContentsTitle from '../../components/molecules/ContentsTitle'
import Tab from '../../components/molecules/Tab'
import ContentsWrapper from '../../components/organisms/ContentsWrapper'
import Description from '../../components/molecules/Description'
import Divider from '../../components/atoms/Divider'
import commaSeparator from '../../utils/number'
import { weiToEther } from '../../utils/dataFormat'
import PageLoading from '../../components/organisms/PageLoading'
import { TableLink } from './styles'

function BlockDetails() {
  const navigate = useNavigate()
  const { blockId } = useParams() as { blockId: string }
  const onNextBlock = () => blockId !== undefined && navigate(`/block/${Number(blockId) + 1}`)
  const onPrevBlock = () => blockId !== undefined && navigate(`/block/${Number(blockId) - 1}`)

  const {
    blockDetails = {
      blockNumber: '',
      timestamp: '',
      txCount: 0,
      blockReward: '',
      symbol: '',
      latestBlock: 0,
    },
    isLoading,
  } = useBlockDetail(blockId)

  return (
    <MainContentDiv>
      <SearchContainer>
        <Search />
      </SearchContainer>
      <ContentsTitle title="Block Details" />
      <Tab items={[{ text: 'Overview' }]} selected="Overview" />{' '}
      <ContentsWrapper>
        <Description
          dataSource={[
            {
              title: 'Block Height',
              desc: blockDetails.blockNumber,
              suffix: (
                <Divider
                  leftText="View previous block"
                  rightText="View next block"
                  rightDisabled={Number(blockDetails.blockNumber) === Number(blockDetails.latestBlock)}
                  leftDisabled={Number(blockDetails.blockNumber) === 1}
                  onClickLeft={onPrevBlock}
                  onClickRight={onNextBlock}
                />
              ),
            },
            {
              title: 'Timestamp',
              desc: (
                <>
                  {dayjs.unix(Number(blockDetails.timestamp)).fromNow()}
                  &nbsp; ({dayjs.unix(Number(blockDetails.timestamp)).utc().format('MMM-DD-YYYY hh:mm:ss a')} +UTC)
                </>
              ),
            },
            {
              title: 'Transactions',
              desc: (
                <TableLink to={`/block/${blockDetails.blockNumber}/txs`}>
                  {`${commaSeparator(blockDetails.txCount)} transactions`}
                </TableLink>
              ),
            },
            {
              title: 'Block Reward',
              desc: (
                <>
                  {weiToEther(blockDetails.blockReward)} {blockDetails.symbol}
                </>
              ),
            },
          ]}
        />
      </ContentsWrapper>
      <PageLoading loading={isLoading} />
    </MainContentDiv>
  )
}

export default BlockDetails
